import { render, staticRenderFns } from "./BCXVuelidateErrors.vue?vue&type=template&id=516bede1"
import script from "./BCXVuelidateErrors.vue?vue&type=script&lang=ts"
export * from "./BCXVuelidateErrors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports